<template>
  <a-checkbox-group v-model:value="innerValue" @change="onChange">
    <a-checkbox v-for="item in options" :key="item.valCode" :value="item.valCode">
      {{ item.valName }}
    </a-checkbox>
  </a-checkbox-group>
</template>

<script lang="ts">
import { defineComponent, onMounted, PropType, ref, watch } from "vue";
import { DictValRecord } from "@/views/system/dict/dict.interface";
import { DictService } from "@/views/system/dict/dict.service";

/**
 * 全局组件: 字典多选
 *
 * 使用方式:
 * <dict-checkbox-group v-model:value="formRef.dictCodes" code="sex"></dict-checkbox-group>
 */
export default defineComponent({
  isGlobal: true,
  name: "DictCheckboxGroup",
  props: {
    code: {
      type: String,
      required: true,
    },
    value: {
      type: Array as PropType<string[]>,
      default: [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:value"],
  setup(props, { emit }) {
    const innerValue = ref<string[]>([]);
    const options = ref<DictValRecord[]>([]);

    const onChange = (code) => {
      emit("update:value", code);
    };

    onMounted(async () => {
      if (!props.code) {
        return;
      }
      options.value = await DictService.fetchOptionsByDictCode(props.code);
    });

    watch(
      () => props.value,
      (value) => {
        innerValue.value = value;
      },
      { immediate: true }
    );

    return {
      innerValue,
      options,
      onChange,
    };
  },
});
</script>
